<dialog
  #glossaryDialog
  (close)="onDialogClose()"
  (click)="onBackdropClick($event)"
  aria-labelledby="spark-glossary-title"
  class="ml-auto h-dvh max-h-none w-full max-w-md bg-transparent p-0 backdrop:bg-black/50"
>
  <div
    class="flex h-full flex-col gap-y-5 overflow-y-auto border-l border-border bg-card p-6 scrollbar-transparent"
  >
    <header class="flex flex-row items-start justify-between gap-x-4">
      <div class="flex flex-col gap-y-1">
        <p class="m-0 text-xs font-bold tracking-[0.08em] text-brand-studio uppercase">
          Plain English
        </p>
        <h2 id="spark-glossary-title" class="m-0 text-2xl font-bold text-primary">Glossary</h2>
      </div>
      <button
        type="button"
        (click)="close()"
        class="shrink-0 cursor-pointer rounded-full border border-border p-2 text-secondary transition-colors hover:text-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
      >
        <span class="sr-only">Close the glossary</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
          class="size-4"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </header>

    <dl class="m-0 flex flex-col divide-y divide-border">
      @for (entry of glossaryService.entries; track entry.term) {
        <div class="flex flex-col gap-y-1 py-4 first:pt-0">
          <dt class="text-base font-bold text-primary">{{ entry.term }}</dt>
          <dd class="m-0 text-sm leading-relaxed text-secondary">{{ entry.definition }}</dd>
        </div>
      }
    </dl>

    <p class="m-0 text-sm text-muted-foreground">
      Still stuck? Your Studio success team replies in under 2 hours.
    </p>
  </div>
</dialog>
